import { Slide } from '@features/powerpoint';
import { mediumSlide } from './medium/slide';
import { dimensionSlide } from './dimension/slide';
import { mediumTable } from './medium/components/medium-table';
import { notes } from './medium/components/notes';

const CONTENT_AREA_WIDTH = 11.82;
const TABLE_Y = 2;
const LEFT_MARGIN = 0.74;

export const lciGuidelineMinimumsSlides = (): Slide[] => [
  mediumSlide({
    buildNotes: notes,
    table: mediumTable({
      options: {
        rowH: 0.3,
        x: LEFT_MARGIN,
        y: TABLE_Y,
        w: CONTENT_AREA_WIDTH,
      },
    }),
  }),
  dimensionSlide(),
];
